<template>
    <div class="d-flex align-center" :style="`justify-content:${justify}`">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: ['justify']
}
</script>
